<template>
  <div>
    <!-- Default settings -->
    <p class="text-primary underline text-right cursor-pointer" @click="onApplyDefaultSettings">
      {{ $t('mygwf.components.User.ReportChart.apply_default_settings') }}
    </p>
    <hr class="my-4" />

    <!-- Chart list -->
    <ul class="chart-list">
      <draggable v-model="chartOptions" v-bind="dragOptions" class="d-flex">
        <li v-for="option of chartOptions" :key="option.label" class="flex items-center py-1">
          <BaseCheck v-model="option.selected" :disabled="option.disabled" />
          <span>{{ option.label }}</span>

          <BaseButtonIcon
            class="mx-2 text-gray-500"
            size="sm"
            :icon="option.type === 'bar' ? 'chart' : 'chart-area'"
            @click="toggleType(option)"
            :tooltip="
              option.type === 'bar'
                ? $t('mygwf.components.User.ReportChart.change_chart_line')
                : $t('mygwf.components.User.ReportChart.change_chart_bar')
            "
          />

          <BaseIcon class="ml-auto text-2xl cursor-move handle" icon="drag-vertical" />
        </li>
      </draggable>
    </ul>

    <!-- Action buttons -->
    <div class="action-buttons flex justify-end mt-4">
      <BaseButton action="" size="sm" context="secondary" @click="onClose">
        {{ $t('mygwf.components.Button.cancel') }}
      </BaseButton>
      <BaseButton action="" size="sm" class="ml-2" @click="onApplySettings">
        {{ $t('mygwf.components.Button.apply') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import {BaseButton, BaseCheck, BaseIcon, BaseButtonIcon} from '@/components/base'
import draggable from 'vuedraggable'
import _cloneDeep from 'lodash-es/cloneDeep.js'

export default {
  components: {
    BaseButton,
    BaseButtonIcon,
    BaseCheck,
    BaseIcon,
    draggable,
  },

  props: {
    meterType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      originalOptions: [],
      chartOptions: [],
      dragOptions: {
        handle: '.handle',
        ghostClass: 'ghost',
        animation: 150,
        direction: 'horizontal',
      },
      saveSettingsTimer: null,
    }
  },

  watch: {
    meterType() {
      this.populateChartOptions()
    },
  },

  created() {
    this.populateChartOptions()
  },

  methods: {
    onApplyDefaultSettings() {
      this.$store.dispatch('reports/charts/resetToDefaultSettings', this.meterType)
      this.populateChartOptions()
    },

    toggleType(option) {
      this.chartOptions.forEach((e, index) => {
        if (e.chart === option.chart) {
          e.type = option.type === 'line' ? 'bar' : 'line'
        }
      })
    },

    onClose() {
      this.chartOptions = _cloneDeep(this.originalOptions)
      this.$emit('close')
    },

    onApplySettings() {
      clearTimeout(this.saveSettingsTimer)

      const settings = this.chartOptions.map(e => ({c: e.chart, v: e.selected, t: e.type}))
      const payload = {meterType: this.meterType, settings}

      this.saveSettingsTimer = setTimeout(() => {
        this.$store.dispatch('reports/charts/saveSettings', payload)
        this.originalOptions = _cloneDeep(this.chartOptions)
      }, 200)
    },

    populateChartOptions() {
      const userSettings = this.$store.getters['reports/charts/getCurrentSettings'](this.meterType)
      const chartData = this.$store.getters['reports/charts/getChartData']
      this.chartOptions = userSettings.map(entry => {
        return {
          chart: entry.c,
          label: chartData[entry.c].title,
          selected: entry.v,
          disabled: entry.c === 'totalVolume',
          type: entry.t,
        }
      })
      this.originalOptions = _cloneDeep(this.chartOptions)
    },
  },
}
</script>

<style scoped>
.ghost {
  opacity: 0.4;
}
</style>
